module.exports = {
    hasCompontentsPage: false,
    hasAppCheck: false,
    functions: {
        BASE_URL: 'https://timeworx.io',
        GET_IN_TOUCH: 'api/getInTouch',
        ALPHA_REGISTRATION: 'api/alphaRegistration',
        ALLOWLIST_REGISTRATION: 'api/allowlistRegistration'
    },
}